export default __webpack_public_path__ + "static/media/the-Internet.1cca7432.png";